/* eslint-disable max-len */
import React,{useState,useEffect,useCallback, useContext} from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import HeaderContext from '../../Components/Context/HeaderContext'
import { DistributorActions } from '../../redux/actions'
import { WishlistedProduct } from '../../redux/helper/AddWishlist'
import { distributorService } from '../../service/distributor.service'
import Product from './Product'
import ProductDetailShimmer from './ProductDetailShimmer'
import './style.css'

function ProductDetail({GetCartItems}) {
    const {
        SetErrorMessage,
        colorValue,
        setcolorValue, } = useContext(HeaderContext);
    const { id } = useParams();
    const [loading, setloading] = useState(true);
    const [wishProducts, setwishProducts] = useState([])
    const [Cart, setCart] = useState([]);
    const [showRelated, setshowRelated] = useState(false)
    const [ProductDetails, setProductDetails] = useState({
        Products:{},
        related_products:[],
        related_offers:[]
    })
    const handleError=(related)=>{
        SetErrorMessage(related?.message);
        setcolorValue(!colorValue);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }
    const handleFetch =  useCallback(
        async() => {
            const details= await distributorService.GetProductDetails(id);
            if(details?.data?.success_status && details.data.data){
                setProductDetails((state)=>({
                    ...state,
                    Products:details.data.data
                }));
                const list= await WishlistedProduct();
                setwishProducts(list)
            }else{
                handleError(details?.message?.response?.data)
            }
            GetCartItems()
            const payload={
                "segments":details.data.data.CATEGORY_CONCAT_SEGS,
            }
            Promise.all([getRelatedProduct(payload),getRelatedOffers(payload)]).then(()=>{
                getCart()            
                setloading(false)
            })
           
            getCart()            
            setloading(false)
            
        },
        [id],
    )
    const getRelatedProduct = async(payload)=>{
        const related= await distributorService.GetRelatedProducts(payload);
        if(related.data.success_status && related.data.data){
            setProductDetails((state)=>({
                ...state,
                related_products:related.data.data
            }));
        }else{
            handleError(related)
        }
    }
    
    const getRelatedOffers = async(payload)=>{
        payload.page=1;
        payload.limit=10;
        payload.CATEGORY_CONCAT_SEGS=payload.segments;
        payload.segments=undefined
        const related= await distributorService.GetRelatedOffers(payload);
        if(related.data.success_status && related.data.data.Items){
            setProductDetails((state)=>({
                ...state,
                related_offers:related.data.data.Items
            }));
        }else{
            handleError(related)
        }
          
            
        
    }
    
    const getCart=async()=>{
        const related= await distributorService.CartItems();
        if(related.data.success_status && related.data.data){
            setCart(related?.data?.data?.cart_items)
        }else{
            handleError(related)
        }   

    }
    const {Products,related_products,related_offers} = ProductDetails
    useEffect(() => {
        handleFetch()
    }, [handleFetch])
    
    return (
        <>
            {loading?<ProductDetailShimmer />:<Product 
                Product={Products}
                relatedProducts={related_products}
                relatedOffers={related_offers}
                wishProducts={wishProducts}
                handlefetch={handleFetch}
                showRelated={showRelated}
                setshowRelated={setshowRelated}
                Cart={Cart}/>
            }</>
    )
}
const mapStateToProps = (state) => {
    const  { Products,FilterData,Cart } = state;
    return {Products,FilterData,Cart}

}
const mapDispatchToProps = {
    GetCartItems:DistributorActions.GetCartItems
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail)
